<template>
  <div class="container">
    <!-- 顶部 -->
    <div class="topBg"><nyTit  pathUrl='/gbyunying'/></div>
    <div class="bottomBg"></div>
    <div class="center"><navItem /></div>
    <!-- 内容 -->
    <div class="content">
      <div class="left">
        <!-- 农田介绍 -->
        <div  class="leftBox1">
          <div class="title"><span>高标准农田</span></div>
            <div class="leftContent1" >
            <div class="leftContent1Left"><img src="../assets/img/plant/img.jpg" /></div>
            <div class="leftContent1Right">
              <div class="leftContent1RightTit">上蔡高标农田</div>
              <!-- <marquee behavior="scroll" direction="up"  width="100%" height="200px" class="textScroll">{{text}}</marquee> -->
              <div class="textScroll">{{state.text}}</div>
            </div>
          </div>  
        </div>
        <!-- 种植产品 -->
        <div class="leftBox2">
            <div class="title1">种植产品</div>
          <LeftBar />
<!--          <div class="leftBox2_content">-->
<!--&lt;!&ndash;            <div class="leftBox2_content_tit" >&ndash;&gt;-->
<!--&lt;!&ndash;              <span :class="{leftBox2_content_titCur:state.left2DataIndex==index}" v-for="(item,index) in state.left2Data" :key="index">{{item.name}}</span>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--            <div class="leftBox2_content_info">-->
<!--              <div class="leftBox2_content_info_item" v-for="(item,index) in state.left2Data" :key="index">-->
<!--                <div class="name">{{item.name}}</div>-->
<!--                <div class="value">{{item.value}}<i>{{item.unit}}</i></div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
      <div class="center"></div>
      <div class="right">
        <!-- 智能设备 -->
        <div class="rightBox1">
          <div class="rightBox1_l">
            <div class="title"><span>智能设备</span></div>
            <div class="rightBox1_l_content">
              <div class="rightItem1" v-for="(item,index) in state.rightData" :key="index">
                <div class="iconBox">
                  <div class="iconBoxBg"><img :src="item.icon" class="icon" /></div>
                </div>
                <div class="rightItem1Right">
                  <div class="rightItem1Right1">
                    <div class="rightItem1Right1Left">{{item.name}}</div>
                    <div class="rightItem1Right1Right"><span>{{item.isLine+item.noLine}}</span>盏</div>
                  </div>
                  <div class="rightItem1Right2">
                    <div class="rightItem1Right2Item">
                      <div class="status">在线</div>
                      <div class="num"><span>{{item.isLine+item.noLine}}</span>盏</div>
                    </div>
                    <div class="rightItem1Right2Item">
                      <div class="status">开启</div>
                      <div class="num"><span>{{item.isLine}}</span>盏</div>
                    </div>
                    <div class="rightItem1Right2Item">
                      <div class="status">离线</div>
                      <div class="num"><span>{{item.noLine}}</span>盏</div>
                    </div>
                  </div>
                </div>
                <img src="../assets/img/plant/jt.png" class="rightJiantou" />
              </div>
              <div class="line"></div>
            </div>
          </div>
          <div class="rightBox1_r">
            <div class="title"><span>设备监控</span></div>
            <div class="rightBox1_r_content">
                <div class="videoBox" id="video"><vue3VideoPlay :control="false"  :controlBtns="false" color="#ff0000" width="100%" height="100%" title="冰河世纪" :src="state.options.src" :type="state.options.type" :autoPlay="true"  @play="onPlay" /></div>
<!--              <div class="videoBox" id="video"><vue3VideoPlay :control="false"  :controlBtns="false" color="#ff0000" width="120%" height="150%" title="冰河世纪" :src="state.options.src" :type="state.options.type" :autoPlay="true"  @play="onPlay" /></div>-->
            </div>
          </div>
        </div>
        <div class="rightBox2">
          <div class="title1"><span>空气湿度趋势</span></div>
          <div class="echarts"><RightBar/></div>
        </div>
        <div class="rightBox3">
          <div class="title1"><span>种植类型</span></div>
          <div class="echarts"><dv-scroll-board :config="state.config" style="width:100%;height:100%" /></div>
        </div>

<!--        <Box2 title="空气质量趋势"  pathName="plant">-->
<!--          <RightLine/>-->
<!--        </Box2>-->
      </div>
    </div>
  </div>
  <footer1 />
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import {
  reactive,
  toRefs,
  ref,
  onMounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance
} from "vue";


// import Left1Line from "../components/cangchu/left1Line";


import nyTit from '@/components/nyTit'
import navItem from '@/components/nyNav'
import RightBar from '../components/plant/RightBar.vue'
import LeftBar from '../components/plant/LeftBar.vue'
import RightSwiper from '../components/plant/RightSwiper.vue'
import txtScroll from "../components/xiaofeiChanpin/txtScroll.vue"
import footer1 from "../components/footer.vue";
import { useRouter } from 'vue-router'


import { setInterval, clearInterval } from "timers";

    const { proxy } = getCurrentInstance();
    // const timer = ref(null);
    const router = useRouter();
    const state = reactive({
      currentTime: "",
      text:"上蔡县5万亩高标准农田示范区项目，位于上蔡县西南部，与遂平县5万亩高标准农田示范区相连成片，项目共涉及无量寺、大路李、黄埠3个乡镇的14个行政村和1个农场、1个种子站，建设面积5万亩，计划投资1.5亿元。",
      textList:[
        {title:'上蔡县5万亩高标准农田示范区建设项目涉及无量寺乡、黄埠镇2个乡镇的10个行政村，其中，其中无量寺乡涉'},
        {title:'及王连湖村、后陈村、吴宋村、陈寨庙村、郝庄村；黄埠镇涉及冯坡村、狮子口村、周庄村、后张村和常庄村等10个行政村。'},
        {title:'上蔡县5万亩高标准农田示范区建设项目涉及无量寺乡、黄埠镇2个乡镇的10个行政村，其中，其中无量寺乡涉'},
        {title:'及王连湖村、后陈村、吴宋村、陈寨庙村、郝庄村；黄埠镇涉及冯坡村、狮子口村、周庄村、后张村和常庄村等10个行政村。'},
        {title:'上蔡县5万亩高标准农田示范区建设项目涉及无量寺乡、黄埠镇2个乡镇的10个行政村，其中，其中无量寺乡涉'},
        {title:'及王连湖村、后陈村、吴宋村、陈寨庙村、郝庄村；黄埠镇涉及冯坡村、狮子口村、周庄村、后张村和常庄村等10个行政村。'},
        ] ,
      left2Data:[
            {name:"小麦亩产量",value:890,unit:"公斤"},
            {name:"小麦高标亩产量",value:890,unit:"公斤"},
            {name:"小麦总产量",value:890,unit:"吨"},

            {name:"玉米亩产量",value:890,unit:"公斤"},
            {name:"玉米高标亩产量",value:890,unit:"公斤"},
            {name:"玉米总产量",value:890,unit:"吨"},
            {name:"大豆亩产量",value:890,unit:"公斤"},
            {name:"大豆高标亩产量",value:890,unit:"公斤"},
            {name:"大豆总产量",value:890,unit:"吨"}

          ],
      rightData:[
        {name:"杀虫灯",isLine:17,noLine:0,icon:require('@/assets/img/plant/zm.png')},
        {name:"监控摄像头",isLine:11,noLine:0,icon:require('@/assets/img/plant/sxt.png')},
        {name:"水肥一体机",isLine:28,noLine:0,icon:require('@/assets/img/plant/xf.png')},
      ],
      options:{
        src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nysp/7.mp4", //视频源
        type: 'video/mp4', //视频类型
      },
      config: {
        header: ['<span style="display:block;color:#94E894;background: linear-gradient(to bottom, #064E52 25%, #091718 95%);">种植日期</span>', '<span style="color:#94E894">种植区域</span>', '<span style="color:#94E894">种植类型</span>','<span style="color:#94E894">是否收获</span>'],
        data: [
          ["2023.10.06", "上蔡", "小麦","否"],
          ["2023.10.06", "上蔡", "小麦","否"],
          ["2023.10.06", "上蔡", "小麦","否"],
          ["2023.10.06", "上蔡", "小麦","否"],
          ["2023.10.06", "上蔡", "小麦","否"],
          ["2023.10.06", "上蔡", "小麦","否"],
          ["2023.10.06", "上蔡", "小麦","否"],
          ["2023.10.06", "上蔡", "小麦","否"],
        ],
        headerHeight:"64",
        headerBGC: "",
        oddRowBGC: "",
        evenRowBGC: "",
        // index: true,
        // columnWidth: [150],
        align: ["center","center","center","center"],
        rowNum:4
      },
    });
    onMounted(() => {
      // clearInterval(state.timer.value);
      // state.value = setInterval(() => {
      //   state.currentTime = proxy.$utils.getCurrentTime();
      // }, 1000);
       
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
      
    })
    const onPlay = (ev) => {
      console.log('播放')
    }
    // 返回上一页
    function clickReturn(){
      router.go(-1);
    }
// 鼠标经过
    function mouseenter(index){
      // let rightData1 = 
      state.navList[index].animateShow = true
    }
    // 鼠标离开
    function mouseleave(index){
      // let rightData1 = 
      state.navList[index].animateShow = false
    }

</script>
<style lang="less" scoped>
::v-deep .d-play-btn {
  width: 50px !important;
  height: 50px !important;
}
::v-deep .d-player-state{
  top: 50%;
  margin-top: -25px;
}
::v-deep .d-icon{
  font-size: 20px!important;
}
::v-deep .header{
  background: linear-gradient(to bottom, #064E52 25%, #091718 95%);
}
::v-deep .header-item,::v-deep .ceil{
  font-size: 26px;

}
.scrolling-text-container {
  height: 100px; /* 设置容器的高度 */
  overflow: hidden;
}

.scrolling-text-content {
  display: block;
  height: 200%; /* 假设此处为两倍于容器高度 */
  line-height: 1.5; /* 根据实际情况设置行高 */
  white-space: nowrap;
  transform: translateY(0);
}
body {
  background-size: cover;
  line-height: 1.15;
}
@font-face {
  font-family: electronicFont;
  src: url("../assets/font/DS-DIGIT.TTF");
}
.container{
  width: 100%;
  height: 100vh;
  background: url("../assets/img/plant/bg1.jpg") no-repeat top center;
  background-size: 100% 100%;
  color: #fff;
  position: relative;
  overflow: hidden;
  // 头部
  .topBg{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 432px;
    background: url("../assets/img/gbzntyj/bingchong/s.png") no-repeat;
    z-index: 1;
  }
  .bottomBg{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 432px;
    background: url("../assets/img/gbzntyj/bingchong/x.png") no-repeat;
  }
  .center{
    position: absolute;
    bottom: 90px;
    left: 50%;
    width: 2000px;
    margin-left: -1000px;

  }
  .title{
    width: 972px;
    height: 130px;
    line-height: 40px;
    background: url("../assets/img/gbzntyj/qixiang1/cgx.png") no-repeat left bottom;
    color: #fff;
    font-size: 40px;
    margin: 20px auto 0;
    position: relative;
    z-index: 999;
    span{
      background: linear-gradient(to bottom, #fff 25%, #FFD791 95%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-weight: bold;
    }
  }
  .title1{
    background: url("../assets/img/plant/title.png") no-repeat left bottom;
    width: 100%;
    height: 70px;
    line-height: 60px;
    color: #fff;
    font-size: 32px;
    text-align: left;
    padding-left: 60px;
    margin-bottom: 20px;
  }
  .echarts{
    flex: 1;
    width: 100%;
  }
  // 内容
  .content{
    display: flex;
    width: 100%;
    min-height: 1005;
    box-sizing: border-box;
    padding: 20px 20px 0;
    .left,.right{
      width: 1562px;
      height: calc(100vh - 154px);;
      display: flex;
      flex-direction: column;
      background: #081314;
      position: absolute;
      top: 154px;
    }
    .center{
      flex: 1;
    }
    .right{right: 0}
    .left{
      left: 0;
      padding: 0 112px;
      display: flex;
      flex-direction: column;
      .leftBox1{
        .leftContent1{
          display: flex;
          justify-content: center;
          height: 500px;
          .leftContent1Left{
            width: 595px;
            height: 500px;
            background: url("../assets/img/plant/tpk.png") no-repeat top center;
            background-size: 100% 100%;
            padding: 20px;
            box-sizing: border-box;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .leftContent1Right{
            width: 595px;
            height: 500px;
            background: url("../assets/img/plant/leftRightBg.png") no-repeat top center;
            background-size: 100% 100%;
            margin-left: 50px;
            overflow: hidden;
            .leftContent1RightTit{
              font-size: 36px;
              height: 100px;
              line-height: 100px;
              position: relative;
              z-index: 999;
            }

            .textScroll{
              width: 100%;
              font-size: 30px;
              line-height:54px;
              text-align: left;
              padding: 0 50px 30px;
              box-sizing: border-box;
              // animation: textScroll 4s linear infinite;
              overflow: hidden;
              // border: 1px solid #f00;
            }
          }
        }
      }
      .leftBox2{
        padding: 50px 0;
        display: flex;
        flex-direction: column;
        flex: 1;
        .leftBox2_content{
          width: 100%;
          flex: 1;
          .leftBox2_content_tit{
            width: 100%;
            height:88px ;
            display: flex;
            span{
              display: block;
              width: 219px;
              height: 88px;
              background: url("../assets/img/plant/wxz.png") no-repeat;
              font-size: 30px;
              text-align: center;
              line-height: 88px;
              padding-top: 10px;
              margin: 0 20px;
            }
            .leftBox2_content_titCur{
              background: url("../assets/img/plant/xz.png") no-repeat;
              color: #00FFEA;
            }
          }
          .leftBox2_content_info{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            //margin-top: 50px;
            .leftBox2_content_info_item{
              width: 30%;
              font-size: 36px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              margin: 20px 0;
              .name{
                width: 306px;
                position: relative;
                padding-left: 30px;
                line-height: 60px;
                text-align: left;
                margin-bottom: 10px;
              }
              .name:before{
                position: absolute;
                content: "";
                top: 18px;
                left: 0;
                display: block;
                width: 15px;
                height: 20px;
                background: #00F5E1;
              }
              .value{
                width: 306px;
                height: 100px;
                background: url("../assets/img/plant/ls.png") no-repeat;
                background-size: 100% 100%!important;
                text-align: center;
                line-height: 100px;
                font-size: 40px;
                color: #00F2DE;
                i{
                  color: #fff;
                  font-size: 26px;
                  margin-left: 10px;
                  font-style: normal;
                }
              }
            }
            .leftBox2_content_info_item:nth-child(7),.leftBox2_content_info_item:nth-child(8),.leftBox2_content_info_item:nth-child(9){
              .name:before{
                background:#E5B36C;
              }
              .value{
                background: url("../assets/img/plant/hs.png") no-repeat;
                color: #E5B36C;
              }
            }
          }
        }
      }


    }
    // 左三

    .right{
      right: 0;
      .rightBox1{
        width: 100%;
        height: 530px;
        display: flex;
        .title{
          width: 100%;
          height: 100px;
          background: url("../assets/img/plant/dbt.png") no-repeat center bottom;
        }
        .rightBox1_l{
          flex: 1;
          display: flex;
          flex-direction: column;
          // 右一
          .rightBox1_l_content{
            width: 100%;
            flex: 1;
            box-sizing: border-box;
            text-align: center;
            scrollbar-width: none; /* firefox */
            -ms-overflow-style: none; /* IE 10+ */
            overflow-x: hidden;
            overflow-y: auto;
            margin-top: -30px;
            .rightItem1{
              display: flex;
              width: 640px;
              height: 136px;
              margin: 20px 30px;
              background-size:contain!important;
              position: relative;
              // margin-right: 30px;
              .iconBox{
                width: 136px;
                height: 136px;
                background-size:cover!important;
                position: absolute;
                left:20px;
                top: 10px;
                animation: opacity 2s linear infinite;
                animation-delay: 1s;
                .iconBoxBg{
                  width: 102px;
                  height: 102px;
                  background-size:cover!important;
                  position: absolute;
                  left:17px;
                  top: 19px;
                  .icon{
                    width: 50px;
                    height: 46px;
                    position: absolute;
                    left: 26px;
                    top: 23px;
                    animation: opacity 1s linear infinite;

                  }
                }
              }
              .rightItem1Right{
                margin-left: 140px;
                margin-right: 32px;
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                font-size: 30px;

                .rightItem1Right1{
                  width: 100%;
                  display: flex;
                  justify-content: space-between;
                  line-height: 32px;
                  margin-top: 33px;
                  margin-left: 30px;
                  .rightItem1Right1Left{
                    color: #E3FCE3;
                  }
                  .rightItem1Right1Right{
                    color: #93E593;
                    margin-right: 10px;
                    span{
                      font-size: 26px;
                      font-weight: bold;
                      margin-right: 5px;
                    }
                  }
                }
                .rightItem1Right2{
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  margin-top:20px;
                  font-size: 26px;
                  .rightItem1Right2Item{
                    width: 100%;
                    .num{
                      span{
                        font-size: 30px;
                        margin-right: 5px;
                      }
                    }
                  }
                }
              }
            }
            .rightItem1:nth-child(1){
              background: url("../assets/img/plant/rightItem1.png") no-repeat top right;
              .iconBox{
                background: url("../assets/img/plant/lwq.png") no-repeat;
                .iconBoxBg{
                  background: url("../assets/img/plant/lnq.png") no-repeat;
                }
              }
            }
            .rightItem1:nth-child(2){
              background: url("../assets/img/plant/rightItem2.png") no-repeat top right;
              .iconBox{
                background: url("../assets/img/plant/cwq.png") no-repeat;
                .iconBoxBg{
                  background: url("../assets/img/plant/cnq.png") no-repeat;
                }
              }
            }
            .rightItem1:nth-child(3){
              background: url("../assets/img/plant/rightItem3.png") no-repeat top right;
              .iconBox{
                background: url("../assets/img/plant/wql.png") no-repeat;
                .iconBoxBg{
                  background: url("../assets/img/plant/nql.png") no-repeat;
                }
              }
            }
            .rightJiantou{
              width: 25px;
              height: 19px;
              position: absolute;
              top: 18px;
              right: 0;
              animation: jiantou 1s linear infinite;
            }
          }
          .rightBox1::-webkit-scrollbar,.centerList::-webkit-scrollbar{
            display: none; /* Chrome Safari */
          }
        }
        .rightBox1_r{
          flex: 1;
          display: flex;
          flex-direction: column;
          margin-right: 50px;
          .rightBox1_r_content{
            display: flex;
            justify-content: space-between;
            flex: 1;
            height:100%;
            .videoBox{
              width: 100%;
              height: 100%;
              background: #102F29;
              border: 1px solid #35FFD2;
              padding: 10px;
              overflow: hidden;
              margin: 0 50px 0 80px;
            }
          }
        }
      }
    }

    .line{
      width: 479px;
      height: 5px;
      background: url("../assets/img/plant/x.png") no-repeat;
      position: absolute;
      bottom: 0;
      left: 0;
    }
      //  右二   
     .rightBox2{
      display: flex;
      justify-content: space-between;
      width: 100%;
      flex: 1;
       margin: 30px 0;
       padding: 0 50px;
       display: flex;
       flex-direction: column;
       .title1{
         margin-bottom: 30px;
       }
     }
    .rightBox3{
      width: 100%;
      flex: 1;
      padding: 0 100px;
      display: flex;
      flex-direction: column;
    }
  }
}


#video .d-player-wrap {
  object-fit: cover;
  // background-color: #ff0000 !important;
  background-color: transparent !important; /* 设置背景色为透明 */
}

@keyframes textScroll {
    0% {
        transform: translateY(0);
    }
   100% {
        transform: translateY(-100%);
    }
}  
@keyframes flowCss {
      0% {
          /* 移动背景位置 */
          background-position: 0 0;
      }

      100% {
          background-position: -400% 0;
      }
  }

@keyframes bianda {    /*引用动画名称*/
  /* from表示动画的开始位置，也可以使用0%来表示。 */
  0%{                     
      transform: scale(0.3);
  } 
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  50%{
    transform: scale(1);
  }
   100%{
    transform: scale(0.3);
  }
}
@keyframes navLine {    /*引用动画名称*/
  /* from表示动画的开始位置，也可以使用0%来表示。 */
  0%{                      
      left: 0;
  } 
  50%{                       
      left: 85%;
  }
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  100%{
    left:0
  }
}
@keyframes infoLine {    /*引用动画名称*/
  /* from表示动画的开始位置，也可以使用0%来表示。 */
  0%{                     
      
      left: 0;
  } 
  50%{                     
      
      left: 60%;
  }
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  100%{
    left:0
  }
}
/* 定义关键帧 */
@keyframes guangying {    /*引用动画名称*/
  0% {
          transform: rotate(0deg);
      }

  100% {
      transform: rotate(-360deg);
  }
}
/* 定义关键帧 */
@keyframes opacity {    /*引用动画名称*/
  0% {
         filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
      }

  50% {
        filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.5));
  }
  100% {
         filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
      }
}
@keyframes left2 {    /*引用动画名称*/
  0% {
         filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
         transform: scale(0.8);
         transform: rotate(0);
      }

  50% {
        filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.2));
        transform: scale(1.02);
        transform: rotate(10deg);
  }
  100% {
         filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
         transform: scale(0.9);
         transform: rotate(0);
      }
}
@keyframes jiantou {    /*引用动画名称*/
  /* from表示动画的开始位置，也可以使用0%来表示。 */
  0%{                     
      
      right: 0;
      transform: scale(1);
  } 
  50%{                     
      
      right: 5px;
      transform: scale(1.01);
  }
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  100%{
    right: 0;
    transform: scale(1);
  }
}
@keyframes topIcon {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
    transform: scale(.9);
  }
  75% {
    transform: rotate(-15deg);
    // transform: scale(.9);
  }
   100% {
    transform: rotate(0);
  }
}
</style>
